export interface Certificaat {
  certificaatNummer: string;
  landVanAfgifte: string;
  datumVanAfgifte: Date;
}
